export const SPECIAL_OFFER_EVENT_NAME = 'special-offer-click';

export const SPECIAL_OFFER_DATA_TEST = {
  RELATED: 'special-offer-related',
  BUTTONS: 'special-offer-buttons',
  BUTTON_OFFER_LIST: 'button-offer-list',
  TAB_OFFER_LIST: 'tab-offer-list',
  BUTTON_BOOKING: 'button-booking',
  DEALER_SEARCH: 'dealer-search',
  DOWNLOAD_MY_ISUZU: 'special-offer-download-my-isuzu',
  BOOKING_MYI: 'booking-myi',
  BOOKING_LINE: 'booking-line',
  DEALER_CONTACT: 'dealer-contact',
  DEALER_LINE: 'dealer-line',
  DEALER_MAP: 'dealer-map',
};
